<template>
  <div>
    <base-header type="gradient-default" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/empresa/desafios'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de desafios"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-8 col-md-10">
            <p class="text-white my-3">
              Aqui você pode conferir as equipes já cadastradas no desafio.
              Novas equipes criadas apareceram aqui.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col text-right">
          <base-button
            type="link"
            :custom="true"
            class="text-white"
            @click="
              $router.push(
                `/empresa/desafios/${$route.params.id}/equipes-ranking`
              )
            "
            ><i class="fas fa-chevron-up"></i> Visualizar ranking</base-button
          >
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div v-if="empty" class="row">
            <div class="col-12 mb-3 text-center">
              <badge type="info" class="bg-white">
                Não existem equipes cadastradas até o momento
              </badge>
            </div>
          </div>
          <div v-if="!empty">
            <div class="row">
              <div class="col-12">
                <div class="card-deck">
                  <div
                    class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
                    v-for="equipe in equipes"
                    :key="equipe.id"
                  >
                    <div class="card flex-grow-1 border-0">
                      <div class="card-body py-3">
                        <h2 class="card-title mb-1">Equipe {{ equipe.id }}</h2>
                        <p class="card-text mt-2 mb-0" v-if="equipe.name">
                          <span :title="equipe.name">{{
                            truncate(equipe.name)
                          }}</span>
                        </p>
                        <p class="mt-2 mb-0">
                          <span>
                            {{ equipe.description }}
                          </span>
                        </p>
                      </div>
                      <div class="card-footer text-center">
                        <router-link
                          :to="
                            '/empresa/desafios/' +
                              $route.params.id +
                              '/equipes/' +
                              equipe.id +
                              '/submissoes'
                          "
                          class="btn btn-white py-1 px-2"
                          v-tooltip="'Visualizar a equipe e submissões'"
                          >Visualizar equipe
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-muted text-right mt-3">
                <b>{{ equipes.length }}</b> equipes cadastradas ao total
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "desafios_equipes_list",
  data() {
    return {
      equipes: [],
      empty: false,
      placeholderImg: "/img/pages/default_banner_course.jpg"
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.equipes_list,
      width: 150,
      height: 150,
      opacity: 0
    });
    try {
      const { data } = await api.get(
        `/company/challenges/${this.$route.params.id}/teams`
      );
      if (data.length) this.equipes = data;
      else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os módulos da trilha");
    }
  },
  methods: {
    truncate(text, stop = 150, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    }
  }
};
</script>
<style scoped>
.card-img-top {
  height: 200px;
  margin: auto;
  object-fit: cover;
}

.card-image {
  position: relative;
  height: 200px;
}

.image-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0.2;
  transition: 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
}

.card:hover .image-overlay {
  opacity: 1;
}
</style>
